module.exports = __webpack_public_path__ + "static/media/nissan-regular.2f49f483.woff";